import { motion } from "framer-motion";
import { Card, CardContent } from "../../components/ui/card";
import {
  Brain, Search, TrendingUp, Clock, ShieldCheck, Award
} from "lucide-react";

// Static list of marketing features. Kept colocated with the section that
// renders it to keep `LandingPage.js` lean.
const FEATURES = [
  {
    icon: Brain,
    title: "IA Intelligente",
    description: "Notre agent IA analyse votre profil et trouve les marchés les plus adaptés à votre expertise.",
  },
  {
    icon: Search,
    title: "Données BOAMP en temps réel",
    description: "Accédez aux marchés publics directement depuis le Bulletin Officiel des Marchés Publics.",
  },
  {
    icon: TrendingUp,
    title: "Score de Compatibilité",
    description: "Visualisez instantanément votre niveau de correspondance avec chaque appel d'offres.",
  },
  {
    icon: Clock,
    title: "Gain de Temps",
    description: "Plus besoin de passer des heures à chercher. Recevez les meilleures opportunités directement.",
  },
  {
    icon: ShieldCheck,
    title: "Données Officielles",
    description: "Toutes les informations proviennent des sources officielles BOAMP et sont mises à jour en temps réel.",
  },
  {
    icon: Award,
    title: "Aide au Mémoire",
    description: "Notre IA vous aide à rédiger des mémoires techniques percutants et convaincants.",
  },
];

/**
 * "Pourquoi choisir Mon DCE Express ?" — 6-card feature grid.
 * Self-contained, no external state.
 */
export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-slate-900 mb-4">
            Pourquoi choisir Mon DCE Express ?
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Des outils puissants pour maximiser vos chances de succès aux appels d&apos;offres
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map((feature) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <Card
                className="h-full bg-white border-slate-100 hover:shadow-lg transition-all duration-300 group"
                data-testid={`feature-card-${feature.title}`}
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-violet-100 to-indigo-100 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                    <feature.icon className="w-7 h-7 text-violet-700" />
                  </div>
                  <h3 className="font-display text-xl font-semibold text-slate-900 mb-3">{feature.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{feature.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
